import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = ({ items }) => {
  const navigate = useNavigate();

  const handleClick = (path) => {
    if (path) {
      navigate(path);
    }
  };

  return (
    <nav className="breadcrumb" aria-label="Breadcrumb navigation">
      {items?.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && (
            <Icon 
              name="ChevronRight" 
              size={16} 
              className="breadcrumb-separator"
            />
          )}
          {item?.path ? (
            <button
              onClick={() => handleClick(item?.path)}
              className="breadcrumb-item"
              aria-label={`Navigate to ${item?.label}`}
            >
              {item?.icon && (
                <Icon 
                  name={item?.icon} 
                  size={16}
                />
              )}
              <span>{item?.label}</span>
            </button>
          ) : (
            <span className="breadcrumb-current">
              {item?.icon && (
                <Icon 
                  name={item?.icon} 
                  size={16}
                />
              )}
              <span>{item?.label}</span>
            </span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;